import {
  faChartPieSimpleCircleDollar,
  faMinus,
} from '@fortawesome/pro-regular-svg-icons';
import { Zuschlag } from '../../entities';
import { Badge } from '@/components/ui/badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function ZuschlaegeCell({ zuschlaege }: { zuschlaege: Zuschlag[] }) {
  return (
    <Badge
      className={`px-2 py-1.5 space-x-2 h-8 w-[50px] bg-neutrals-N200`}
      variant="secondary">
      <FontAwesomeIcon
        icon={faChartPieSimpleCircleDollar}
        className={
          zuschlaege.length > 0
            ? 'text-primary-blue-B600'
            : 'text-neutrals-N600'
        }
        size="lg"
      />
      {zuschlaege.length > 0 ? (
        <span className="text-black font-bold">{zuschlaege.length}</span>
      ) : (
        <FontAwesomeIcon
          icon={faMinus}
          size="sm"
          className="text-neutrals-N600 font-thin"
        />
      )}
    </Badge>
  );
}
